"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.STREAM_LEVEL_1080P = exports.STREAM_LEVEL_720P = exports.STREAM_LEVEL_480P = exports.STREAM_LEVEL_360P = exports.STREAM_LEVEL_240P = exports.STREAM_LEVEL_AUTO = void 0;
var STREAM_LEVEL_AUTO = -1;
exports.STREAM_LEVEL_AUTO = STREAM_LEVEL_AUTO;
var STREAM_LEVEL_240P = 0;
exports.STREAM_LEVEL_240P = STREAM_LEVEL_240P;
var STREAM_LEVEL_360P = 1;
exports.STREAM_LEVEL_360P = STREAM_LEVEL_360P;
var STREAM_LEVEL_480P = 2;
exports.STREAM_LEVEL_480P = STREAM_LEVEL_480P;
var STREAM_LEVEL_720P = 3;
exports.STREAM_LEVEL_720P = STREAM_LEVEL_720P;
var STREAM_LEVEL_1080P = 4;
exports.STREAM_LEVEL_1080P = STREAM_LEVEL_1080P;